import { render, staticRenderFns } from "./PortfolioHeader.vue?vue&type=template&id=28b60ffd&"
import script from "./PortfolioHeader.vue?vue&type=script&lang=js&"
export * from "./PortfolioHeader.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports